module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/signature-9dc5c4eb306600757d57de960eda7056.svg";